const patientDashboardGetterFunc = ({ data: { patientDashboard } }) => {

    return ({
        patientDashboard
    })
}

export { patientDashboardGetterFunc as patientDashboardGetter };